import { render, staticRenderFns } from "./payment-description.vue?vue&type=template&id=8aab863c&scoped=true"
import script from "./payment-description.ts?vue&type=script&lang=ts&external"
export * from "./payment-description.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-description.scss?vue&type=style&index=0&id=8aab863c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aab863c",
  null
  
)

export default component.exports